<dx-popup
    *ngIf="!!userBio"
    [height]="'auto'"
    [showTitle]="true"
    [resizeEnabled]="true"
    [minWidth]="isSmallScreen ? popupWidth : undefined"
    [maxWidth]="!isSmallScreen ? popupWidth : undefined"
    [maxHeight]="isSmallScreen ? '90%' : '85%'"
    [showCloseButton]="true"
    [title]="userBio?.displayName"
    [(visible)]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let item of 'content'" class="dx-theme-accent-as-border-color user-bio-container">
        <dx-form
            #userBioForm
            width="100%"
            height="100%"
            [colCount]="5"
            class="user-bio-content"
            [scrollingEnabled]="true"
            [ngClass]="{ hidden: !userBio }"
        >
            <dxi-item>
                <img [src]="userBio?.photoUrl" class="user-image" />
            </dxi-item>
            <dxi-item [colSpan]="2">
                <div *ngIf="userBio?.businessRoleTitle">
                    <a [href]="userBio?.businessRoleHelpLink" target="_blank">{{ userBio?.businessRoleTitle }}</a>
                </div>
                <div *ngIf="userBio?.managementCompany">{{ userBio?.managementCompany }}</div>
                <div *ngIf="userBio?.location">
                    {{ userBio?.location }}
                    <span *ngIf="userBio?.satelliteOffice">, {{ userBio?.satelliteOffice }}</span>
                </div>
                <div *ngIf="userBio?.department">{{ userBio?.department }}</div>
                <div *ngIf="userBio?.departmentEmail">
                    <a href="mailto:{{ userBio?.departmentEmail }}">{{ userBio?.departmentEmail }}</a>
                </div>
                <br />
                <div *ngIf="showPortalAssignments">
                    <a href="javascript:void(0)" (click)="portalAssignmentClick()">
                        Portfolio Assignments&nbsp;
                        <i [ngClass]="lockIcon"></i>
                    </a>
                </div>
            </dxi-item>
            <dxi-item [colSpan]="2">
                <div *ngIf="userBio?.officePhone">
                    Office:
                    <a href="tel:{{ userBio?.officePhone }}">{{ userBio?.officePhone }}</a>
                </div>
                <div *ngIf="userBio?.mobilephone">
                    Mobile:
                    <a href="tel:{{ userBio?.mobilephone }}">{{ userBio?.mobilephone }}</a>
                </div>
                <div *ngIf="userBio?.shoretelPhone">
                    3CX Number:
                    <a href="tel:{{ userBio?.shoretelPhone }}">{{ userBio?.shoretelPhone }}</a>
                </div>
                <div *ngIf="userBio?.email">
                    Email:
                    <a href="mailto:{{ userBio?.email }}">{{ userBio?.email }}</a>
                </div>
                <div *ngIf="userBio?.supervisor">
                    Reports To:
                    <span>{{ userBio?.supervisor }}</span>
                </div>
                <br />
                <div *ngIf="userBio?.community">
                    <a *ngIf="userBio?.communityUrl" [href]="userBio?.communityUrl" target="_blank">
                        {{ userBio?.community }}
                    </a>
                    <span *ngIf="!userBio?.communityUrl">{{ userBio?.community }}</span>
                </div>
                <div *ngIf="userBio?.communityEmail">
                    <a href="mailto:{{ userBio?.communityEmail }}">{{ userBio?.communityEmail }}</a>
                </div>
                <div *ngIf="userBio?.communityServiceTeamUrl">
                    <a [href]="userBio?.communityServiceTeamUrl" target="_blank">Community Service Team</a>
                </div>
            </dxi-item>
            <dxi-item [colSpan]="5" *ngIf="!!userBioSections && userBioSections.length > 0">
                <div *dxTemplate>
                    <dx-accordion
                        #sectionAccordion
                        width="100%"
                        height="auto"
                        noDataText=""
                        class="user-bio-section dx-theme-border-color"
                        [focusStateEnabled]="false"
                        [hoverStateEnabled]="false"
                        [dataSource]="userBioSections"
                        [collapsible]="false"
                        [multiple]="false"
                        [animationDuration]="300"
                    >
                        <div *dxTemplate="let rec of 'title'" class="user-bio-section-title dx-theme-border-color">
                            <h5>
                                {{ rec.title }}
                                <i *ngIf="rec.icon" [ngClass]="rec.icon"></i>
                            </h5>
                        </div>
                        <div *dxTemplate="let rec of 'item'" class="user-bio-section-body" [ngSwitch]="rec.id">
                            <ng-container
                                *ngSwitchCase="'PA'"
                                [ngTemplateOutlet]="assignments"
                                [ngTemplateOutletContext]="{ data: rec.data }"
                            ></ng-container>
                            <ng-container
                                *ngSwitchCase="'AV'"
                                [ngTemplateOutlet]="achivements"
                                [ngTemplateOutletContext]="{ data: rec.data }"
                            ></ng-container>
                            <ng-container
                                *ngSwitchCase="'CL'"
                                [ngTemplateOutlet]="certificates"
                                [ngTemplateOutletContext]="{ data: rec.data }"
                            ></ng-container>
                            <ng-container
                                *ngSwitchCase="'ED'"
                                [ngTemplateOutlet]="education"
                                [ngTemplateOutletContext]="{ data: rec.data }"
                            ></ng-container>
                            <ng-container *ngSwitchDefault>
                                <div
                                    *ngIf="rec.data"
                                    class="user-bio-default"
                                    [innerHTML]="rec.data | ccSafeHtml"
                                ></div>
                            </ng-container>
                        </div>
                    </dx-accordion>
                </div>
            </dxi-item>
            <dxi-item itemType="group" [colSpan]="5" [colCount]="1">
                <dxi-item itemType="empty"></dxi-item>
                <dxi-item>
                    <div *dxTemplate>
                        <ng-container *ngIf="userBio?.allowManageBio" [ngTemplateOutlet]="actionButtons"></ng-container>
                    </div>
                </dxi-item>
            </dxi-item>
        </dx-form>
    </div>
</dx-popup>

<dx-load-panel
    [position]="{ of: '#userBioForm' }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<ng-template #assignments let-data="data">
    <dx-data-grid height="100%" [dataSource]="data" [showBorders]="true">
        <dxo-group-panel [visible]="false"></dxo-group-panel>
        <dxo-load-panel [enabled]="false"></dxo-load-panel>

        <dxi-column dataField="company" [groupIndex]="0"></dxi-column>
        <dxi-column dataField="location"></dxi-column>
        <dxi-column dataField="community"></dxi-column>
        <dxi-column dataField="role"></dxi-column>
    </dx-data-grid>
</ng-template>

<ng-template #achivements let-data="data">
    <dx-tile-view
        width="100%"
        direction="vertical"
        class="user-bio-tileview"
        [dataSource]="data"
        [baseItemHeight]="100"
        [baseItemWidth]="150"
        [itemMargin]="10"
        [showScrollbar]="always"
    >
        <div *dxTemplate="let d of 'item'" class="user-bio-badge" [title]="d.description">
            <img
                *ngIf="!d.showRemoteBadgeImage"
                [src]="d.localBadgeImage"
                [alt]="d.description"
                (error)="onBadgeImageError(d)"
            />
            <img *ngIf="d.showRemoteBadgeImage" [src]="d.remoteBadgeImage | async" [alt]="d.description" />
            <br />
            {{ d.name }}
        </div>
    </dx-tile-view>
</ng-template>

<ng-template #certificates let-data="data">
    <ul class="user-bio-link">
        <li *ngFor="let d of data">
            <a [href]="d.helpLink" target="_blank">{{ d.title }}</a>
        </li>
    </ul>
</ng-template>

<ng-template #education let-data="data">
    <div class="user-bio-table">
        <div
            *ngFor="let d of data; let idx = index"
            class="user-bio-table-row"
            [ngClass]="{ 'user-bio-table-ruler dx-theme-border-color': idx > 0 }"
        >
            <div *ngIf="d.school" class="user-bio-table-col">
                <b>School:</b>
                {{ d.school }}
            </div>
            <div *ngIf="d.degree" class="user-bio-table-col">
                <b>Degree:</b>
                {{ d.degree }}
            </div>
            <div *ngIf="d.campus" class="user-bio-table-col">
                <b>Campus:</b>
                {{ d.campus }}
            </div>
        </div>
    </div>
</ng-template>

<ng-template #actionButtons>
    <dx-toolbar width="width">
        <dxi-item location="before">
            <div *dxTemplate>
                <dx-button type="default" text="Close" hint="Close" [icon]="iconClose" (onClick)="hide()"></dx-button>
            </div>
        </dxi-item>
        <!-- Removing Edit, Delete and Approve button from User biography as per DEV-3755 -->
    </dx-toolbar>
</ng-template>

<app-portfolio-assignments
    *ngIf="displayPortfolioAssignment"
    [visible]="displayPortfolioAssignment"
    [portfolioAssignmentData]="portfolioAssignmentData"
    [popUpTitle]="portfolioAssignmentTitle"
    (portfolioAssignmentClose)="displayPortfolioAssignment = false"
></app-portfolio-assignments>
